import { Search } from 'lucide-react';
import type { ReactNode } from 'react';

interface DataToolbarProps {
  icon: ReactNode;
  title: string;
  count: number;
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
  action?: ReactNode;
}

/** Đầu bảng: tiêu đề + số lượng + ô tìm kiếm. */
export function DataToolbar({
  icon,
  title,
  count,
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Tìm kiếm...',
  action,
}: DataToolbarProps) {
  return (
    <div className="border-line flex items-center justify-between border-b px-5 py-4">
      <div className="text-ink flex items-center gap-2 text-[14px] font-semibold">
        {icon}
        <span>{title}</span>
        <span className="bg-accent-soft text-accent rounded-full px-2 py-0.5 text-[11px] font-bold">
          {count}
        </span>
        {action}
      </div>
      <div className="relative">
        <Search
          size={14}
          className="text-ink-faint pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2"
        />
        <input
          type="text"
          value={searchValue}
          onChange={(e) => {
            onSearchChange(e.target.value);
          }}
          placeholder={searchPlaceholder}
          className="border-line bg-canvas text-ink placeholder:text-ink-faint focus:border-accent w-64 rounded-lg border py-1.5 pl-8 pr-2.5 text-[12px] outline-none transition-colors"
        />
      </div>
    </div>
  );
}
